<template>
	<div>
		<div class="detail-infos__subheading" v-if="showSubheading">
			<h2 class="detail-infos__subheading--label">{{ $t('WEBAPP_SYNOPSIS') }}</h2>
		</div>

		<p class="text-wrap-pre-line mt-0">
			{{ synopsis }}
		</p>

		<small
			v-if="originalShortDescription"
			style="display: block; clear: both; margin-top: -8px; margin-bottom: 8px"
			@click.prevent="showOriginal = !showOriginal"
		>
			{{ showOriginal ? $t('WEBAPP_DESCRIPTION_SHOW_TRANSLATED') : $t('WEBAPP_DESCRIPTION_SHOW_ORIGINAL') }}
		</small>
	</div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = withDefaults(
	defineProps<{
		shortDescription?: string;
		originalShortDescription?: string;
		showSubheading?: boolean;
	}>(),
	{
		shortDescription: '',
		originalShortDescription: '',
		showSubheading: true,
	}
);

const showOriginal = ref(false);

const synopsis = computed<string>(() => (showOriginal.value ? props.originalShortDescription : props.shortDescription));
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.text-wrap-pre-line {
	white-space: pre-line;
}

ul {
	color: $jw-color-lightgray--dark;
	font-size: 16px;
}
</style>
